/**************************************************
 * Nombre:       Dashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import DashboardBase from "../Modulo_Dashboard/Componentes/DashboardBase";
import React, {createContext, useContext, useEffect, useState} from "react";
import {
    BadgeOutlined,
    CampaignOutlined,
    CreditScoreOutlined,
    FaceRetouchingNaturalOutlined,
    PublishedWithChangesOutlined,
    ReadMoreOutlined,
    SupportAgentOutlined,
    TaskOutlined,
    WalletOutlined
} from "@mui/icons-material";
import {funSalir} from "../Servicios/Auth/funSalir";
import {usuarioContext} from "../App";
import Seccion_Usuarios from "./Secciones/Seccion_Usuarios";
import Seccion_Administradores from "./Secciones/Seccion_Administradores";
import Seccion_Depositos from "./Secciones/Seccion_Depositos";
import Seccion_Movimientos from "./Secciones/Seccion_Movimientos";
import Seccion_Contratos from "./Secciones/Seccion_Contratos";
import Seccion_Retiros from "./Secciones/Seccion_Retiros";
import Seccion_Canjes from "./Secciones/Seccion_Canjes";
import Seccion_Soporte from "./Secciones/Seccion_Soporte";
import Seccion_Noticias from "./Secciones/Seccion_Noticias";
import Seccion_Movimientos_ID from "./SeccionesID/Seccion_Movimientos_ID";
import Seccion_ContratosID from "./SeccionesID/Seccion_ContratosID";
import Seccion_EquipoID from "./SeccionesID/Seccion_EquipoID";
import Seccion_Movimientos_Usuario from "./SeccionesID/Seccion_Movimientos_Usuario";


export const contexBarra = createContext()
const Dashboard = () => {
    const [notificaciones, setNotificaciones] = useState([])
    const [nuevasNotificaciones, setNuevasNotificaciones] = useState(0)
    const [historial, setHistorial] = useState([])
    const [nuevoHistorial, setNuevoHistorial] = useState(0)
    const {usuario} = useContext(usuarioContext)

    const [open, setOpen] = useState(false)
    const salir = () => {
        funSalir()
    }

    const valoresBarra = {
        notificaciones,
        nuevasNotificaciones,
        historial,
        nuevoHistorial,
        funSalir: salir

    }


    const {Provider} = contexBarra;


    useEffect(() => {


    }, [usuario]);
    return (
        <Grid
            container
            size={12}
        >


            <Provider value={valoresBarra}>
                <DashboardBase secciones={secciones} seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}/>
            </Provider>

        </Grid>
    )

}
export default Dashboard

const secciones = [

    {
        nombre: 'Usuarios',
        icono: FaceRetouchingNaturalOutlined,
        camino: '/Usuarios',
        categoria: 'Usuarios',
        Componente: <Seccion_Usuarios/>
    },
    {
        nombre: 'Depositos',
        icono: CreditScoreOutlined,
        camino: '/Depositos',
        categoria: 'Plataforma',
        Componente: <Seccion_Depositos/>
    },
    {
        nombre: 'Contratos',
        icono: TaskOutlined,
        camino: '/Contratos',
        categoria: 'Plataforma',
        Componente: <Seccion_Contratos/>
    },
    {
        nombre: 'Retiros',
        icono: WalletOutlined,
        camino: '/Retiros',
        categoria: 'Plataforma',
        privada: true,
        Componente: <Seccion_Retiros/>
    },
    {
        nombre: 'Canjes',
        icono: PublishedWithChangesOutlined,
        camino: '/Canjes',
        categoria: 'Plataforma',
        privada: true,
        Componente: <Seccion_Canjes/>
    },
    {
        nombre: 'Soporte',
        icono: SupportAgentOutlined,
        camino: '/Soporte',
        categoria: 'Plataforma',
        privada: true,
        Componente: <Seccion_Soporte/>
    },
    {
        nombre: 'Noticias',
        icono: CampaignOutlined,
        camino: '/Noticias',
        categoria: 'Plataforma',
        privada: true,
        Componente: <Seccion_Noticias/>
    },
    {
        nombre: 'Administradores',
        icono: BadgeOutlined,
        camino: '/Administradores',
        categoria: 'Configuraciones',
        privada: true,
        Componente: <Seccion_Administradores/>
    },
    {
        nombre: 'Movimientos',
        icono: ReadMoreOutlined,
        camino: '/Movimientos',
        categoria: 'Configuraciones',
        privada: true,
        Componente: <Seccion_Movimientos/>
    }
]

const seccionesID = [

    {
        camino: '/MovimientosID/:tipo/:id',
        Componente: <Seccion_Movimientos_ID/>
    },
    {
        camino: '/ContratosID/:tipo/:id',
        Componente: <Seccion_ContratosID/>
    },
    {
        camino: '/EquipoID/:id',
        Componente: <Seccion_EquipoID/>
    },
    {
        camino: '/UsuarioMovID/:id',
        Componente: <Seccion_Movimientos_Usuario/>
    }
]

const seccionesPerfil = []

const notificaciones = {}